import * as React from 'react'
import { DateField } from '@doordash/component-fields'

export const DateComponent = React.memo(({ ...props }) => {
  return <DateField {...props} />
})
